import { useCallback, useEffect, useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";

interface SearchBarProps {
  onSearch?: (keyword: string) => void
}
export const SearchBar = ({onSearch}: SearchBarProps) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [mounted, setMounted] = useState(false);
  const [keyword, setKeyword] = useState('')

  const search = useCallback(() => {
    if (onSearch) {
      onSearch(keyword)
    }
    if (keyword.startsWith('0x')) {
      navigate(`/web/asset/detail/${keyword}/1`)
    } else {
      navigate(`/web/search?keyword=${keyword}`)
    }
  }, [keyword, navigate, onSearch]);

  useEffect(() => {
    if (mounted) return;
    setMounted(true);
    if (searchParams.has('keyword')) {
      setKeyword(searchParams.get('keyword') || '');
    }
  }, [keyword, mounted, searchParams])

  return (
    <>
      <Form.Group controlId="formSearch">
        <InputGroup className="mx-auto" style={{ maxWidth: '560px', width: '95%' }}>
          <Form.Control
            autoFocus
            type="text"
            placeholder="可透過合約位址進行搜尋"
            value={keyword}
            onChange={(e) => {
              e.preventDefault();
              setKeyword(e.target.value);
            }}
            onKeyUp={e => {
              if (e.key === 'Enter') {
                search();
              }
            }}
          />
          <InputGroup.Text className="cursor-pointer px-3" style={{ borderRadius: '0 12px 12px 0' }} onClick={search}>搜尋</InputGroup.Text>
        </InputGroup>
      </Form.Group>
    </>
  )
}